
import Vue from "vue";
import StatusCard from "@/components/StatusCard.vue";

export default Vue.extend({
  components: { StatusCard },
  props: {
    isLoading: {
      type: Boolean,
      default: true,
    },
    modelsStatusAll: {
      type: Object,
    },
  },
  computed: {
    statusItems() {
      return [
        {
          value: this.modelsStatusAll.allNormalModel,
          label: "Normal",
          bgColor: "bg-[#2EC577]/[0.2]",
        },
        {
          value: this.modelsStatusAll.allWarningModel,
          label: "Warning",
          bgColor: "bg-[#FCA239]/[0.2]",
        },
        {
          value: this.modelsStatusAll.allAlarmModel,
          label: "Alarm",
          bgColor: "bg-[#D9263B]/[0.2]",
        },
        {
          value: this.modelsStatusAll.allStopModel,
          label: "Stop Run",
          bgColor: "bg-[#A5ACB3]/[0.2]",
        },
      ];
    },
  },
});
